import { Configuration } from '@azure/msal-browser';
import { PlatformModulesEnum } from '@thinknet-gmbh/platform-common';

export const AXIOS_AUTH_CONFIG = {
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/auth`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Platform-Module': PlatformModulesEnum.YUU_HR_MODULE,
  },
};

export const MSAL_CONFIG: Configuration = {
  auth: {
    authority: 'https://login.microsoftonline.com/consumers',
    clientId: process.env.REACT_APP_MICROSOFT_AUTH_CLIENT_ID || '',
    redirectUri: `${process.env.REACT_APP_FRONTEND_URL}/`,
    postLogoutRedirectUri: `${process.env.REACT_APP_FRONTEND_URL}/`,
  },
  cache: {
    storeAuthStateInCookie: false,
    cacheLocation: 'memoryStorage',
  },
};

export const MSAL_TOKEN_CONFIG = {
  scopes: [process.env.REACT_APP_MICROSOFT_SCOPE],
};
